import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import classes from '../../../../commonStyles/tables.module.css';

const OccSummaryDataRow = ({ row }) => {
    return (
        <TableRow hover className={classes.basicRowStripes}>
            <TableCell>{row.eventDate || ' - '}</TableCell>
            <TableCell>{row.visits === 'zz' ? ' - ' : row.visits}</TableCell>
            <TableCell>{row.group === 'zz' ? ' - ' : row.group}</TableCell>
            <TableCell>{row.type === 'zz' ? ' - ' : row.type}</TableCell>
        </TableRow>
    );
};

OccSummaryDataRow.propTypes = {
    row: PropTypes.object
};

export default OccSummaryDataRow;
